import { Component, ErrorInfo, ReactNode } from "react";
import styles from "./ErrorBoundary.module.css";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className={styles["error-boundary"]}>
            <h2>Что-то пошло не так</h2>
            <p>Пожалуйста, попробуйте перезагрузить страницу</p>
            <button onClick={() => window.location.reload()}>Перезагрузить страницу</button>
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
